<template>
    <div class='line' >
        <div :class='col1Class()' @click='goToHostPage()'>{{ hostObj.name }} {{ hostObj.description }}</div>
        <div class='col col2'>{{ hostObj.active ? "Oui" : "Non"}}</div>
        <div class='col col3' >
            <button class="mdl-button mdl-js-button mdl-button--icon btn_add" @click='goToHostPage()'>
                <i class="material-icons">add</i>
            </button>
        </div>

        
        <button v-if="isSuperAdmin()" class="mdl-button mdl-js-button mdl-button--icon btn_editsub btnEdit" @click='clickEditHost()'>
            <i class="material-icons">edit</i>
        </button>
        <button v-if="isSuperAdmin()" class="mdl-button mdl-js-button mdl-button--icon btn_deletesub btnDelete" @click='clicToDeleteHost()'>
            <i class="material-icons">delete</i>
        </button>
    </div> 
</template>

<script>
    import FctUtils from '@/components/FctUtils';
    import { RoleEnum } from '../classes/enums'

    export default {
        name: "HostLine",
        mixins: [FctUtils],
        props:{
            hostObj: {type:Object},
        },
        computed:{


        },
        methods:{
            isSuperAdmin() {
                return this.$store.state.currentUser.role == RoleEnum.SUPERADMIN.value;
            },
            goToHostPage(){
                this.$router.push({name:"Host", params: {hostId: this.hostObj.id} })
            },
            clicToDeleteHost() {
                this.emitter.emit('showPLForm', {mode:'formHost_remove', data:this.hostObj});
            },
            clickEditHost() {
                this.emitter.emit('showPLForm', {mode:'formHost_edit', data:this.hostObj});
            },
            col1Class() {
                var result = 'col col1 ';
                result +=  (this.hostObj.active)? 'green' : 'red'
                return result;
            },
        }
    }
</script>


<style scoped>


#hostTab .col1 {
    width: 300px;
}

#hostTab .col2 {
    width: 170px;
    border-right-width:1px;
}

#hostTab .col3 {
    width:210px;
    padding-left : 8px;

    color: #0075bb;
    font-weight: bold;
    font-size: 18px;
}


.btnDelete {
    position: absolute;
    top:5px;
    right:5px;
}

.btnEdit {
    position: absolute;
    top:5px;
    right:25px;

    color: #0075bb;
}


</style>
